<template>
    <wa-field v-if="settings.system_settings.free_products > 0"
              :name="settings.is_frontend ? field.name : ''"
              :hide_name="(settings.is_frontend && field.name === '') || !settings.is_frontend">
        <hr v-if="!settings.is_frontend"/>
        <div :class="!settings.is_frontend ? 'mb top double clear-both' : ''">
            <div v-if="field.text_before && field.text_before !== '' && settings.is_frontend" v-html="field.text_before"></div>
            <p v-else-if="!settings.is_frontend">{{ $t('Select products, which would be added to certificate') }}</p>
            <div class="free-products" v-if="certificate.products.length">
                <draggable v-model="selectedProductsList" handle=".sort">
                    <div v-for="(product, index) in selectedProductsList"
                         :key="index"
                         class="product-item"
                    >
                        <base-icon16 :id="'sort'"></base-icon16>
                        <span v-html="product.name"></span>
                        <span v-if="product.sku_name"> ({{ product.sku_name }})</span>
                        <a :href="product.url" :title="$t('Open product')" target="_blank">
                            <base-icon16 v-if="!settings.is_frontend" :id="`new-window`"></base-icon16>
                            <i v-else class="gc-icon new-window"></i>
                        </a>
                        <span v-html="product.price" class="product-item-price"></span>
                        <a href="#"
                           @click.prevent="removeSelected(index, product)"
                           v-html="settings.is_frontend ? (field.remove_products || $t('remove')) : $t('remove')"></a>
                    </div>
                </draggable>
            </div>
            <div class="mb top">
                <base-modal :text='settings.is_frontend ? (field.add_products || (`<i class="icon16 add"></i> ` + $t("add products"))) : (`<i class="icon16 add"></i> ` + $t("add products"))'
                            :title="$t('Adding products')"
                            :component="productSearchComponent"
                            :componentParams="{
                                url: this.settings.urls.get_products_search_data,
                                selected: {
                                    url: this.settings.urls.get_products_search_selected,
                                    data: modalSelectedProducts
                                },
                                settings: settings
                            }"
                            :buttons="{
                                submit: {
                                    name: $t('Save'),
                                    onSave: onProductsSearchSave,
                                    closeOnSubmit: true
                                }
                            }"
                            :footer="{
                                component: productSearchFooterComponent
                            }"
                            :modalParams="{ height: '90%', fixedFooter: true, contentId: 'products-search-content', closeCross: true }"
                >&nbsp;
                </base-modal>
            </div>
            <div v-if="field.text_after && field.text_after !== '' && settings.is_frontend" v-html="field.text_after"></div>
        </div>
    </wa-field>
</template>

<script>
import ProductsSearch from "@/components/products_search/";
import TheProductsSearchFooter from "./TheProductsSearchFooter";

export default {
    name: "TheFreeProducts",
    props: ['settings', 'certificate', 'field'],
    components: {
        'draggable': () => import('vuedraggable'),
        'wa-field': () => import('@/components/WaField'),
        'base-icon16': () => import('@/components/base/BaseIcon16'),
        'base-modal': () => import('@/components/base/BaseModal'),
    },
    data() {
        return {
            certificateData: {},
            productSearchComponent: '',
            productSearchFooterComponent: '',
        }
    },
    computed: {
        selectedProductsList: {
            get() {
                return this.certificateData.products;
            },
            set(value) {
                this.$store.commit('ProductSearchModule/update', value);
                this.synchronizeProducts();
            }
        },
        modalSelectedProducts() {
            let data = { skus: [], products: [] };
            if (this.certificateData.products.length) {
                this.certificateData.products.forEach((product) => {
                    data[product.type].push(product.id);
                })
            }
            return data;
        },
        storeProducts() {
            return this.$store.state.ProductSearchModule.selectedProducts.list.map(item => item);
        },
    },
    methods: {
        synchronizeProducts() {
            this.certificateData.products = this.storeProducts;
        },
        removeSelected(index, product) {
            this.$store.commit('ProductSearchModule/remove', { product, type: product.type });
            this.synchronizeProducts();
        },
        onProductsSearchSave() {
            this.synchronizeProducts();
        },
    },
    created() {
        this.certificateData = this.certificate;
        this.productSearchComponent = ProductsSearch;
        this.productSearchFooterComponent = TheProductsSearchFooter;
    }
}
</script>